import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Today from "@/pages/Today";
import Pipeline from "@/pages/Pipeline";
import Bids from "@/pages/Bids";
import FollowUps from "@/pages/FollowUps";
import Settings from "@/pages/Settings";
import EmailView from "@/pages/EmailView";

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <div className="min-h-screen bg-background flex items-center justify-center"><p className="font-mono text-sm text-muted-foreground">AUTHENTICATING...</p></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Today />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/bids" element={<Bids />} />
            <Route path="/followups" element={<FollowUps />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/email/:id" element={<EmailView />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="top-center" toastOptions={{ style: { borderRadius: 14, border: "1px solid #EAE4D6", background: "#FFFFFF", color: "#1F3D3F", boxShadow: "0 6px 20px rgba(31,61,63,0.10)" } }} />
    </AuthProvider>
  );
}

export default App;
